// File này chứa TOÀN BỘ logic gốc - KHÔNG THAY ĐỔI GÌ
// Chỉ wrap để chạy sau khi React đã render DOM

// Sử dụng THREE global từ script tag trong index.html
/* global THREE, TWEEN */

import { initCanvas } from "./canvas.js";
import {
  addQipao,
  setPrizes,
  showPrizeList,
  setPrizeData,
  resetPrize,
  setTranslations
} from "./prizeList.js";
import { NUMBER_MATRIX } from "./config.js";
import { dataTemp, selectWinnersWithRegionalEquality, REGIONAL_QUANTITY_OPTIONS } from "./const.js"
import * as XLSX from 'xlsx';
import i18n from "app/i18n.js";

const ROTATE_TIME = 3000;
const ROTATE_LOOP = 1000;
const BASE_HEIGHT = 1080;

let TOTAL_CARDS,
  btns = {
    enter: null,
    lotteryBar: null,
    lottery: null
  },
  prizes,
  EACH_COUNT,
  ROW_COUNT = 7,
  COLUMN_COUNT = 17,
  COMPANY,
  HIGHLIGHT_CELL = [],
  Resolution = 1;

let camera,
  scene,
  renderer,
  controls,
  threeDCards = [],
  targets = {
    table: [],
    sphere: []
  };

let rotateObj;
let t;

let selectedCardIndex = [],
  rotate = false,
  basicData = {
    prizes: [],
    users: [],
    luckyUsers: {},
    leftUsers: [],
    regionalWinnersCache: {} // Cache pre-selected winners for 8/16 slot prizes
  },
  interval,
  currentPrizeIndex,
  currentPrize,
  isLotting = false,
  currentLuckys = [];

// Đợi DOM và THREE library ready
function waitForDOMAndLibraries() {
  console.log('Waiting for DOM and libraries...', { hasTHREE: !!window.THREE, hasEnter: !!document.getElementById("enter") });

  return new Promise((resolve) => {
    const checkReady = () => {
      // Kiểm tra cả DOM và THREE global
      if (document.getElementById("enter") && window.THREE) {
        console.log('✓ DOM and THREE ready!');
        resolve();
        return true;
      }
      return false;
    };

    // Kiểm tra ngay lập tức
    if (checkReady()) return;

    // Nếu chưa ready, observe DOM
    const observer = new MutationObserver(() => {
      if (checkReady()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Backup: kiểm tra định kỳ cho THREE (trường hợp script load chậm)
    const interval = setInterval(() => {
      console.log('Checking...', { hasTHREE: !!window.THREE, hasEnter: !!document.getElementById("enter") });
      if (window.THREE && document.getElementById("enter")) {
        clearInterval(interval);
        observer.disconnect();
        console.log('✓ DOM and THREE ready (from interval)!');
        resolve();
      }
    }, 100);
  });
}

// Expose function để React component có thể khởi tạo lottery với users data
window.initLotteryWithUsers = async function (userData) {
  await waitForDOMAndLibraries();

  console.log('Starting lottery initialization...');
  initCanvas(); // Khởi tạo canvas animation

  // Update data
  dataTemp.leftUsers = userData.allUsers;
  basicData.markerUsers = userData.markerUsers; // Lưu users có isMarker = true
  basicData.regularUsers = userData.regularUsers; // Lưu users có isMarker = false
  basicData.rawUsers = userData.rawUsers; // Lưu raw data

  initAll();
};

// Khởi tạo sau khi DOM và libraries ready (fallback nếu không có React)
// waitForDOMAndLibraries().then(async () => {
//   console.log('Starting lottery initialization...');
//   initCanvas(); // Khởi tạo canvas animation
//   initAll();
// });

async function initAll() {
  // Lấy DOM elements sau khi đã được React render
  btns.enter = document.querySelector("#enter");
  btns.lotteryBar = document.querySelector("#lotteryBar");
  btns.lottery = document.querySelector("#lottery");

  prizes = dataTemp.cfgData.prizes;
  console.log("🚀 ~ dataTemp:", dataTemp.t('fullName'))
  EACH_COUNT = dataTemp.cfgData.EACH_COUNT;
  COMPANY = dataTemp.cfgData.COMPANY;
  HIGHLIGHT_CELL = createHighlight();
  basicData.prizes = prizes;
  t = dataTemp.t;
  setPrizes(prizes);
  setTranslations(t);

  TOTAL_CARDS = ROW_COUNT * COLUMN_COUNT;

  basicData.leftUsers = dataTemp.leftUsers;
  basicData.luckyUsers = dataTemp.luckyData;

  let prizeIndex = basicData.prizes.length - 1;
  for (; prizeIndex > -1; prizeIndex--) {
    if (
      dataTemp.luckyData[prizeIndex] &&
      dataTemp.luckyData[prizeIndex].length >=
      basicData.prizes[prizeIndex].count
    ) {
      continue;
    }
    currentPrizeIndex = prizeIndex;
    currentPrize = basicData.prizes[currentPrizeIndex];
    break;
  }

  showPrizeList(currentPrizeIndex);
  let curLucks = basicData.luckyUsers[currentPrize.type];
  setPrizeData(currentPrizeIndex, curLucks ? curLucks.length : 0, true);

  // Sử dụng data đã load từ API
  basicData.users = dataTemp.leftUsers;

  initCards();
  animate();
  shineCard();
  initMusic();

  // Kiểm tra xem đã quay hết tất cả giải chưa ngay từ đầu
  checkAllPrizesCompleted();
}

function initCards() {
  let member = basicData.users.slice(),
    length = member.length;

  let isBold = false,
    showTable = basicData.leftUsers.length === basicData.users.length,
    index = 0,
    position = {
      x: (140 * COLUMN_COUNT - 20) / 2,
      y: (180 * ROW_COUNT - 20) / 2
    };

  camera = new THREE.PerspectiveCamera(
    40,
    window.innerWidth / window.innerHeight,
    1,
    10000
  );
  camera.position.z = 3000;

  scene = new THREE.Scene();

  for (let i = 0; i < ROW_COUNT; i++) {
    for (let j = 0; j < COLUMN_COUNT; j++) {
      isBold = HIGHLIGHT_CELL.includes(j + "-" + i);
      var element = createCard(
        member[index % length],
        isBold,
        index,
        showTable
      );

      var object = new THREE.CSS3DObject(element);
      object.position.x = Math.random() * 4000 - 2000;
      object.position.y = Math.random() * 4000 - 2000;
      object.position.z = Math.random() * 4000 - 2000;
      scene.add(object);
      threeDCards.push(object);

      var object = new THREE.Object3D();
      object.position.x = j * 140 - position.x;
      object.position.y = -(i * 180) + position.y;
      targets.table.push(object);
      index++;
    }
  }

  var vector = new THREE.Vector3();

  for (var i = 0, l = threeDCards.length; i < l; i++) {
    var phi = Math.acos(-1 + (2 * i) / l);
    var theta = Math.sqrt(l * Math.PI) * phi;
    var object = new THREE.Object3D();
    object.position.setFromSphericalCoords(800 * Resolution, phi, theta);
    vector.copy(object.position).multiplyScalar(2);
    object.lookAt(vector);
    targets.sphere.push(object);
  }

  renderer = new THREE.CSS3DRenderer();
  renderer.setSize(window.innerWidth, window.innerHeight);
  document.getElementById("container").appendChild(renderer.domElement);

  controls = new THREE.TrackballControls(camera, renderer.domElement);
  controls.rotateSpeed = 0.5;
  controls.minDistance = 500;
  controls.maxDistance = 6000;
  controls.addEventListener("change", render);

  bindEvent();

  if (showTable) {
    switchScreen("enter");
  } else {
    switchScreen("lottery");
  }
}

function setLotteryStatus(status = false) {
  isLotting = status;
}

function bindEvent() {
  document.querySelector("#menu").addEventListener("click", function (e) {
    e.stopPropagation();

    let target = e.target.id;

    // Cho phép các nút save và reset hoạt động mọi lúc
    if (target !== "save" && target !== "reset" && isLotting) {
      if (target === "lottery") {
        rotateObj.stop();
        btns.lottery.innerHTML = t('startSpin');
      } else {
        addQipao(t('spiningWarning', { value: currentPrize.text }));
      }
      return false;
    }
    switch (target) {
      case "welcome":
        switchScreen("enter");
        rotate = false;
        break;
      case "enter":
        removeHighlight();
        addQipao(t('enterLuckyDrawWarning', { value: currentPrize.text }));
        rotate = true;
        switchScreen("lottery");
        break;
      case "reset":
        let doREset = window.confirm(
          t('sureToReset')
        );
        if (!doREset) {
          return;
        }
        window.location.reload();

        break;
      case "lottery":
        // Kiểm tra xem nút đang ở chế độ nào
        const mode = btns.lottery.getAttribute('data-mode') || 'lottery';

        if (mode === 'reset') {
          // Nếu đã quay hết, thực hiện reset
          let doReset = window.confirm(
            t('endLuckyDraw')
          );
          if (!doReset) {
            return;
          }
          addQipao(t('resetLuckyDrawSuccess'));
          addHighlight();
          resetCard();
          currentLuckys = [];
          basicData.leftUsers = Object.assign([], basicData.users);
          basicData.luckyUsers = {};
          basicData.regionalWinnersCache = {}; // Clear regional winners cache on reset
          currentPrizeIndex = basicData.prizes.length - 1;
          currentPrize = basicData.prizes[currentPrizeIndex];
          resetPrize(currentPrizeIndex);
          reset();
          btns.lottery.innerHTML = t('startSpin');
          btns.lottery.setAttribute('data-mode', 'lottery');
          switchScreen("enter");
        } else {
          // Chế độ quay thưởng bình thường
          setLotteryStatus(true);
          saveData();
          changePrize();
          resetCard().then(res => {
            lottery();
          });
          addQipao(t('spiningWarning', { value: currentPrize.text }));
        }
        break;
      case "reLottery":
        if (currentLuckys.length === 0) {
          addQipao(t('notSpinAtAll'));
          return;
        }
        setErrorData(currentLuckys);
        addQipao(t('respinWarning', { value: currentPrize.text }));
        setLotteryStatus(true);
        resetCard().then(res => {
          lottery();
        });
        break;
      case "save":
        // Không gọi AJAX nữa, chỉ xuất Excel
        resetCard().then(res => {
          currentLuckys = [];
          exportData();
        });
        break;
    }
  });

  window.addEventListener("resize", onWindowResize, false);
}

function switchScreen(type) {
  switch (type) {
    case "enter":
      btns.enter.classList.remove("none");
      btns.lotteryBar.classList.add("none");
      transform(targets.table, 2000);
      break;
    default:
      btns.enter.classList.add("none");
      btns.lotteryBar.classList.remove("none");
      transform(targets.sphere, 2000);
      break;
  }
}

function createElement(css, text) {
  let dom = document.createElement("div");
  dom.className = css || "";
  dom.innerHTML = text || "";
  return dom;
}

function createCard(user, isBold, id, showTable) {
  var element = createElement();
  element.id = "card-" + id;

  if (isBold) {
    element.className = "element lightitem";
    if (showTable) {
      element.classList.add("highlight");
    }
  } else {
    element.className = "element";
    element.style.backgroundColor =
      "rgba(0,127,127," + (Math.random() * 0.7 + 0.25) + ")";
  }
  // Hiển thị: Tên khu vực → Tên (cỡ chữ nhỏ) → Code
  element.appendChild(createElement("company", user[2] || "Unknown")); // Area name
  element.appendChild(createElement("name", user[1])); // User name (smaller font)
  element.appendChild(createElement("details", user[0] || "")); // User code
  return element;
}

function removeHighlight() {
  document.querySelectorAll(".highlight").forEach(node => {
    node.classList.remove("highlight");
  });
}

function addHighlight() {
  document.querySelectorAll(".lightitem").forEach(node => {
    node.classList.add("highlight");
  });
}

function transform(targets, duration) {
  for (var i = 0; i < threeDCards.length; i++) {
    var object = threeDCards[i];
    var target = targets[i];

    new TWEEN.Tween(object.position)
      .to(
        {
          x: target.position.x,
          y: target.position.y,
          z: target.position.z
        },
        Math.random() * duration + duration
      )
      .easing(TWEEN.Easing.Exponential.InOut)
      .start();

    new TWEEN.Tween(object.rotation)
      .to(
        {
          x: target.rotation.x,
          y: target.rotation.y,
          z: target.rotation.z
        },
        Math.random() * duration + duration
      )
      .easing(TWEEN.Easing.Exponential.InOut)
      .start();
  }

  new TWEEN.Tween(this)
    .to({}, duration * 2)
    .onUpdate(render)
    .start();
}

function rotateBall() {
  return new Promise((resolve, reject) => {
    scene.rotation.y = 0;
    rotateObj = new TWEEN.Tween(scene.rotation);
    rotateObj
      .to(
        {
          y: Math.PI * 6 * ROTATE_LOOP
        },
        ROTATE_TIME * ROTATE_LOOP
      )
      .onUpdate(render)
      .start()
      .onStop(() => {
        scene.rotation.y = 0;
        resolve();
      })
      .onComplete(() => {
        resolve();
      });
  });
}

function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
  render();
}

function animate() {
  requestAnimationFrame(animate);
  TWEEN.update();
  controls.update();
}

function render() {
  renderer.render(scene, camera);
}

function selectCard(duration = 600) {
  rotate = false;
  let width = 140,
    tag = -(currentLuckys.length - 1) / 2,
    locates = [];

  if (currentLuckys.length > 5) {
    // yPosition[0] = 87 (hàng trên), yPosition[1] = -87 (hàng dưới)
    // Đánh số từ hàng trên xuống dưới: 1-4 ở trên, 5-8 ở dưới
    let yPosition = [87, -87],
      l = selectedCardIndex.length,
      mid = Math.ceil(l / 2);
    tag = -(mid - 1) / 2;
    for (let i = 0; i < mid; i++) {
      locates.push({
        x: tag * width * Resolution,
        y: yPosition[0] * Resolution
      });
      tag++;
    }

    tag = -(l - mid - 1) / 2;
    for (let i = mid; i < l; i++) {
      locates.push({
        x: tag * width * Resolution,
        y: yPosition[1] * Resolution
      });
      tag++;
    }
  } else {
    for (let i = selectedCardIndex.length; i > 0; i--) {
      locates.push({
        x: tag * width * Resolution,
        y: 0 * Resolution
      });
      tag++;
    }
  }

  let text = currentLuckys.map(item => item[1]);
  addQipao(
    `Chúc mừng ${text.join(", ")}`
  );

  // Tính số thứ tự bắt đầu cho lần quay này (dựa vào số người đã trúng trước đó)
  const luckyData = basicData.luckyUsers[currentPrize.type] || [];
  const startNumber = luckyData.length + 1;

  selectedCardIndex.forEach((cardIndex, index) => {
    // Truyền số thứ tự (startNumber + index) vào changeCard
    const winnerNumber = startNumber + index;
    changeCard(cardIndex, currentLuckys[index], winnerNumber);
    var object = threeDCards[cardIndex];
    new TWEEN.Tween(object.position)
      .to(
        {
          x: locates[index].x,
          y: locates[index].y * Resolution,
          z: 2200
        },
        Math.random() * duration + duration
      )
      .easing(TWEEN.Easing.Exponential.InOut)
      .start();

    new TWEEN.Tween(object.rotation)
      .to(
        {
          x: 0,
          y: 0,
          z: 0
        },
        Math.random() * duration + duration
      )
      .easing(TWEEN.Easing.Exponential.InOut)
      .start();

    object.element.classList.add("prize");
    tag++;
  });

  new TWEEN.Tween(this)
    .to({}, duration * 2)
    .onUpdate(render)
    .start()
    .onComplete(() => {
      setLotteryStatus();
      // Cập nhật lại text nút sau khi quay xong
      const mode = btns.lottery.getAttribute('data-mode') || 'lottery';
      if (mode === 'reset') {
        btns.lottery.innerHTML = t('reset');
      } else {
        btns.lottery.innerHTML = t('startSpin');
      }
    });
}

function resetCard(duration = 500) {
  if (currentLuckys.length === 0) {
    return Promise.resolve();
  }

  selectedCardIndex.forEach(index => {
    let object = threeDCards[index],
      target = targets.sphere[index];

    new TWEEN.Tween(object.position)
      .to(
        {
          x: target.position.x,
          y: target.position.y,
          z: target.position.z
        },
        Math.random() * duration + duration
      )
      .easing(TWEEN.Easing.Exponential.InOut)
      .start();

    new TWEEN.Tween(object.rotation)
      .to(
        {
          x: target.rotation.x,
          y: target.rotation.y,
          z: target.rotation.z
        },
        Math.random() * duration + duration
      )
      .easing(TWEEN.Easing.Exponential.InOut)
      .start();
  });

  return new Promise((resolve, reject) => {
    new TWEEN.Tween(this)
      .to({}, duration * 2)
      .onUpdate(render)
      .start()
      .onComplete(() => {
        selectedCardIndex.forEach(index => {
          let object = threeDCards[index];
          object.element.classList.remove("prize");
        });
        resolve();
      });
  });
}

function lottery() {
  // Kiểm tra nếu đang ở chế độ reset thì không cho quay
  const mode = btns.lottery.getAttribute('data-mode') || 'lottery';
  if (mode === 'reset') {
    return;
  }

  btns.lottery.innerHTML = t('endSpin');
  rotateBall().then(() => {
    currentLuckys = [];
    selectedCardIndex = [];
    let perCount = EACH_COUNT[currentPrizeIndex],
      luckyData = basicData.luckyUsers[currentPrize.type],
      leftPrizeCount = currentPrize.count - (luckyData ? luckyData.length : 0);

    // Xác định pool users để quay dựa vào onlyMarker flag
    let availableUsers;

    if (currentPrize.onlyMarker) {
      // Giải chỉ dành cho marker: chỉ quay từ users có isMarker = true
      availableUsers = basicData.leftUsers.filter(user => {
        // Check isMarker từ index thứ 4 của user array [code, fullName, area, isMarker]
        return user[3] === true;
      });
    } else {
      // Giải thường: quay từ tất cả users
      availableUsers = basicData.leftUsers.slice();
    }

    let leftCount = availableUsers.length;

    if (leftCount < perCount) {
      addQipao(`Số người tham gia còn lại không đủ (chỉ còn ${leftCount} người)!`);
      // Không reset, chỉ quay với số người còn lại
      perCount = leftCount;
    }

    if (leftCount === 0) {
      addQipao("Không còn người nào để quay thưởng!");
      btns.lottery.innerHTML = "Bắt đầu quay";
      return;
    }

    // Check if this prize uses regional distribution (quantity in REGIONAL_QUANTITY_OPTIONS and not onlyMarker)
    // onlyMarker prizes use simple random selection regardless of quantity
    let selectedWinners;
    if (REGIONAL_QUANTITY_OPTIONS.includes(currentPrize.count) && !currentPrize.onlyMarker) {
      console.log(`Applying regional equality distribution for ${currentPrize.count} slots prize`);

      // Check if we have cached winners for this prize
      const cacheKey = `prize_${currentPrize.type}`;
      let allWinners;

      if (!basicData.regionalWinnersCache[cacheKey]) {
        // First spin for this prize - select all winners with regional equality
        console.log(`First spin - selecting ${currentPrize.count} winners with regional equality`);
        allWinners = selectWinnersWithRegionalEquality(availableUsers, currentPrize.count);
        basicData.regionalWinnersCache[cacheKey] = allWinners;

        // Log distribution for verification
        const distribution = {};
        allWinners.forEach(user => {
          const area = user[2]?.toString().trim() || 'Unknown';
          distribution[area] = (distribution[area] || 0) + 1;
        });
        console.log('Regional distribution:', distribution);
      } else {
        // Use cached winners
        allWinners = basicData.regionalWinnersCache[cacheKey];
        console.log('Using cached regional winners');
      }

      // Determine how many have already been selected
      const alreadySelected = luckyData ? luckyData.length : 0;

      // Select winners for this spin from the cached list
      selectedWinners = allWinners.slice(alreadySelected, alreadySelected + perCount);

      console.log(`Total winners needed: ${currentPrize.count}, Already selected: ${alreadySelected}, This spin: ${selectedWinners.length}`);
    } else {
      // Original random selection for other prize quantities
      selectedWinners = [];
      const userPool = [...availableUsers];

      for (let i = 0; i < perCount && userPool.length > 0; i++) {
        const luckyId = Math.floor(Math.random() * userPool.length);
        const luckyUser = userPool.splice(luckyId, 1)[0];
        selectedWinners.push(luckyUser);

        if (leftPrizeCount - 1 - i <= 0) {
          break;
        }
      }
    }

    if (selectedWinners.length === 0) {
      addQipao("Không thể chọn người trúng thưởng!");
      btns.lottery.innerHTML = "Bắt đầu quay";
      return;
    }

    // Update currentLuckys and remove from leftUsers
    currentLuckys = selectedWinners;
    selectedWinners.forEach(luckyUser => {
      // Remove from basicData.leftUsers
      const indexInLeftUsers = basicData.leftUsers.findIndex(u => u[0] === luckyUser[0]);
      if (indexInLeftUsers > -1) {
        basicData.leftUsers.splice(indexInLeftUsers, 1);
      }
    });

    // Select random card positions for display
    selectedWinners.forEach(() => {
      let cardIndex = random(TOTAL_CARDS);
      while (selectedCardIndex.includes(cardIndex)) {
        cardIndex = random(TOTAL_CARDS);
      }
      selectedCardIndex.push(cardIndex);
    });

    selectCard();
  });
}

function saveData() {
  if (!currentPrize) {
    return Promise.resolve();
  }

  let type = currentPrize.type,
    curLucky = basicData.luckyUsers[type] || [];

  curLucky = curLucky.concat(currentLuckys);
  basicData.luckyUsers[type] = curLucky;

  if (currentPrize.count <= curLucky.length) {
    currentPrizeIndex--;
    if (currentPrizeIndex <= -1) {
      currentPrizeIndex = 0;
    }
    currentPrize = basicData.prizes[currentPrizeIndex];

    // Kiểm tra xem đã quay hết tất cả giải chưa
    checkAllPrizesCompleted();
  }

  if (currentLuckys.length > 0) {
    return setData(type, currentLuckys);
  }
  return Promise.resolve();
}

// Kiểm tra xem đã quay hết tất cả giải chưa
function checkAllPrizesCompleted() {
  let allCompleted = true;
  for (let i = 0; i < basicData.prizes.length; i++) {
    const prize = basicData.prizes[i];
    const luckyUsers = basicData.luckyUsers[prize.type] || [];
    if (luckyUsers.length < prize.count) {
      allCompleted = false;
      break;
    }
  }

  if (allCompleted) {
    // Đã quay hết tất cả giải, chuyển nút thành Reset
    btns.lottery.innerHTML = t('reset');
    btns.lottery.setAttribute('data-mode', 'reset');
    addQipao(t('endLuckeyDrawNote'));
  } else {
    btns.lottery.setAttribute('data-mode', 'lottery');
  }
}

function changePrize() {
  let luckys = basicData.luckyUsers[currentPrize.type];
  let luckyCount = (luckys ? luckys.length : 0) + EACH_COUNT[currentPrizeIndex];
  setPrizeData(currentPrizeIndex, luckyCount);
}

function random(num) {
  return Math.floor(Math.random() * num);
}

function changeCard(cardIndex, user, winnerNumber = null) {
  let card = threeDCards[cardIndex].element;
  // Hiển thị: Số thứ tự (nếu có) → Tên khu vực → Tên (cỡ chữ nhỏ) → Code
  const numberBadge = winnerNumber ? `<div class="winner-number">${winnerNumber}</div>` : '';
  card.innerHTML = `${numberBadge}<div class="company">${user[2] || "Unknown"}</div><div class="name">${user[1]}</div><div class="details">${user[0] || ""}</div>`;
}

function shine(cardIndex, color) {
  let card = threeDCards[cardIndex].element;
  card.style.backgroundColor =
    color || "rgba(0,127,127," + (Math.random() * 0.7 + 0.25) + ")";
}

function shineCard() {
  let maxCard = 10,
    maxUser;
  let shineCard = 10 + random(maxCard);

  setInterval(() => {
    if (isLotting) {
      return;
    }
    maxUser = basicData.leftUsers.length;
    for (let i = 0; i < shineCard; i++) {
      let index = random(maxUser),
        cardIndex = random(TOTAL_CARDS);
      if (selectedCardIndex.includes(cardIndex)) {
        continue;
      }
      shine(cardIndex);
      changeCard(cardIndex, basicData.leftUsers[index]);
    }
  }, 500);
}

function setData(type, data) {
  return new Promise((resolve, reject) => {
    window.AJAX({
      url: "/saveData",
      data: {
        type,
        data
      },
      success() {
        resolve();
      },
      error() {
        reject();
      }
    });
  });
}

function setErrorData(data) {
  return new Promise((resolve, reject) => {
    window.AJAX({
      url: "/errorData",
      data: {
        data
      },
      success() {
        resolve();
      },
      error() {
        reject();
      }
    });
  });
}

function exportData() {
  // Tạo dữ liệu Excel từ kết quả đã quay
  const exportRows = [];

  // Header
  exportRows.push([t('prize'), t('code'), t('fullName'), t('area')]);

  // Duyệt qua từng giải thưởng
  basicData.prizes.forEach(prize => {
    const luckyUsers = basicData.luckyUsers[prize.type] || [];

    if (luckyUsers.length > 0) {
      luckyUsers.forEach(user => {
        exportRows.push([
          prize.text,           // Tên giải
          user[0] || '',        // Mã nhân viên
          user[1] || '',        // Tên nhân viên
          user[2] || 'Unknown'  // Khu vực
        ]);
      });
    }
  });

  // Tạo workbook và worksheet
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(exportRows);

  // Set column widths
  ws['!cols'] = [
    { wch: 30 }, // Giải thưởng
    { wch: 15 }, // Mã nhân viên
    { wch: 25 }, // Tên nhân viên
    { wch: 20 }  // Khu vực
  ];

  XLSX.utils.book_append_sheet(wb, ws, t('resultLuckyDraw'));

  // Tạo tên file với timestamp
  const now = new Date();
  const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
  const filename = `lucky_draw_${timestamp}.xlsx`;

  // Download file
  XLSX.writeFile(wb, filename);

  addQipao(`${t('exportResultSuccess')} ${filename}`);
}

function reset() {
  window.AJAX({
    url: "/reset",
    success(data) {
      console.log("Đặt lại thành công");
    }
  });
}

function createHighlight() {
  let year = new Date().getFullYear() + "";
  let step = 4,
    xoffset = 1,
    yoffset = 1,
    highlight = [];

  year.split("").forEach(n => {
    highlight = highlight.concat(
      NUMBER_MATRIX[n].map(item => {
        return `${item[0] + xoffset}-${item[1] + yoffset}`;
      })
    );
    xoffset += step;
  });

  return highlight;
}

function initMusic() {
  let music = document.querySelector("#music");
  let rotated = 0,
    stopAnimate = false,
    musicBox = document.querySelector("#musicBox");

  // Kiểm tra xem audio có load được không
  music.addEventListener('error', function () {
    console.warn('Music file not found or cannot be loaded');
    musicBox.style.display = 'none'; // Ẩn music box nếu không có nhạc
  });

  function animateMusic() {
    requestAnimationFrame(function () {
      if (stopAnimate) {
        return;
      }
      rotated = rotated % 360;
      musicBox.style.transform = "rotate(" + rotated + "deg)";
      rotated += 1;
      animateMusic();
    });
  }

  musicBox.addEventListener(
    "click",
    function (e) {
      if (music.paused) {
        // Kiểm tra xem audio đã load được chưa
        if (music.error) {
          addQipao("Không tìm thấy file nhạc, vui lòng thêm file music.mp3 vào thư mục public/data/");
          return;
        }

        music.play().then(
          () => {
            stopAnimate = false;
            animateMusic();
          },
          (e) => {
            console.log("🚀 ~ Lỗi phát nhạc:", e);
            // addQipao("Không thể phát nhạc. Vui lòng kiểm tra file nhạc hoặc quyền trình duyệt.");
          }
        );
      } else {
        music.pause();
        stopAnimate = true;
      }
    },
    false
  );

  // Chỉ auto-click nếu không có lỗi
  setTimeout(function () {
    if (!music.error) {
      musicBox.click();
    }
  }, 1000);
}
